import { Box, Button, Card, CardActions, CardContent, CardMedia, Container, Link, Stack, Typography, createTheme } from "@mui/material";
import MainLayout from "../layouts/main-layout";


export default function Home() {
  return (
    <MainLayout>
      <Box
        sx={{
          bgcolor: 'background.paper',
          pt: 14,
          pb: 6,
        }}
      >
        <Container maxWidth="lg">
          <Typography
            component="h1"
            variant="h4"
            align="center"
            color="text.primary"
            gutterBottom
          >
            ยินดีต้อนรับสู่ QA Web Demo
          </Typography>
          <Typography variant="h5" align="center" color="text.secondary" paragraph>
            เว็บไซท์นี้จัดทำเพื่อการจำลองการทดสอบระบบเท่านั้น
          </Typography>
          <Box sx={{ pt: 6 }}>
            <Stack direction={{ xs: 'column', sm: 'row' }} alignItems="center" justifyContent="center" spacing={3}>
              <Card sx={{ maxWidth: 350 }}>
                <CardContent>
                  <Typography variant="h5" component="div">
                    เลือก Test Framework ไม่ถูก?
                  </Typography>
                  <Typography sx={{pt: 2}} component="h4">
                    ลองทำแบบสอบถามนี้ดู
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button size="small" href='https://docs.google.com/forms/d/e/1FAIpQLScl0q9cUf2llPFDeFhaWRmKjcLn8KO-lokVY5vsc4TUkEDCBQ/viewform' target='_blank'>
                    ทำแบบสอบถาม คลิก
                  </Button>
                </CardActions>
              </Card>
              <Card sx={{ display: 'flex', maxWidth: 350 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <CardContent sx={{ flex: '1 0 auto' }}>
                    <Typography variant="subtitle1" color="text.secondary" component="div">
                      สนับสนุนเราได้ เพียงซื้อ
                    </Typography>
                    <Typography component="div" variant="h6" sx={{color: 'green'}}>
                      <strong>LINE</strong> Sticker
                    </Typography>
                  </CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1 }}>
                    <Button href='https://line.me/S/sticker/24024699/?lang=en&utm_source=gnsh_stickerDetail' target='_blank' >
                      Purchase
                    </Button>
                  </Box>
                </Box>
                <Link target='_blank' href='https://line.me/S/sticker/24024699/?lang=en&utm_source=gnsh_stickerDetail'>
                  <CardMedia
                    component="img"
                    sx={{ width: 151 }}
                    image={require(`../assets/images/line/qa-line-skicker.png`)}
                    alt="Live from space album cover"
                  />
                </Link>
              </Card>
            </Stack>
          </Box>
        </Container>
      </Box>
    </MainLayout>
  )
}